// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-demo[data-v-50f14bfe]{height:1.14583vw;line-height:1}", ""]);
// Exports
module.exports = exports;
